import { tns } from "tiny-slider";

const initHero = () => {
  const carousel = document.querySelector(".js-hero-carousel");
  const navContainer = document.querySelector(".js-nav-container");
  const controlsContainer = document.querySelector(".js-controls-container");

  if (!(carousel instanceof Element)) {
    return;
  }

  if (!(navContainer instanceof Element)) {
    return;
  }

  if (!(controlsContainer instanceof Element)) {
    return;
  }

  tns({
    container: carousel,
    mode: "gallery",
    items: 1,
    loop: true,
    controlsContainer: controlsContainer,
    navContainer: navContainer,
    navPosition: "top",
    mouseDrag: true,
    speed: 600,
    autoplayButtonOutput: false,
    responsive: {
      "640": {
        mouseDrag: false,
        autoplay: true,
        speed: 500,
        autoplayHoverPause: true,
      },
    },
  });
};

export default initHero();
